import React, { Component } from 'react'
import Line from '../Line'
import { translation } from '../../../../utils/helpers'

class ForsiLine extends Component {
  renderPart () {
    let notation = translation('885')
    return (
      <div>
        {this.props.part.Method ? (
          <Line bold text={this.props.part.Name}>
            <Line text={this.props.part.Method} amount={this.props.part.AE} noFormat currencyType={notation} subLine />
          </Line>
        ) : (
          <Line boldText text={this.props.part.Name} amount={this.props.part.AE} noFormat currencyType={notation} subLine />
        )}
      </div>
    )
  }

  renderMethod () {
    const renderText = () => {
      return (
        <div className={'text'}>
          {this.props.method.Code && <span className={'bold'}>{this.props.method.Code} </span>}
          <span>{this.props.method.Name}</span>
        </div>
      )
    }

    return (
      <div onClick={this.props.onClick}>
        <Line text={renderText} />
      </div>
    )
  }

  render () {
    if (this.props.part) return this.renderPart()
    if (this.props.method) return this.renderMethod()
    return null
  }
}

export default ForsiLine



// WEBPACK FOOTER //
// ./src/app/shared/components/Extent/ForsiLine/index.js